import React from "react";

// Shared editorial page hero (bottom-left aligned, architectural)
const PageHero = ({ image, eyebrow, title, subtitle, height = "58vh" }) => (
  <section
    className="relative flex items-end overflow-hidden"
    style={{ height, minHeight: "400px" }}
  >
    <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${image})` }} />
    <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-black/40" />
    <div className="absolute left-6 md:left-9 top-1/2 -translate-y-1/2 hidden md:block">
      <span className="vtext eyebrow text-white/60 text-[10px] tracking-[0.4em]">
        Safranbolu · Karabük
      </span>
    </div>
    <div className="relative z-10 max-w-7xl mx-auto w-full px-6 md:px-12 pb-14">
      <div className="flex items-center gap-4 mb-5">
        <span className="w-10 h-px bg-[#d9b877]" />
        <p className="eyebrow text-[#e7cf9c]">{eyebrow}</p>
      </div>
      <h1 className="font-display text-6xl md:text-8xl text-white font-500 leading-none animate-fade-up">
        {title}
      </h1>
      {subtitle && (
        <p className="text-white/75 mt-4 max-w-md text-[15px] animate-fade-up">{subtitle}</p>
      )}
    </div>
  </section>
);

export default PageHero;
